import rfdc from 'rfdc'

const rfdcFunction = rfdc()
export const deepClone = rfdcFunction
